export default "__VITE_ASSET__Ba3$TuHL__"